import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ent, setEnt] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setEnt(data.entitlement);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = (data) => {
    localStorage.setItem("pp_token", data.token);
    setUser(data.user);
    setEnt(data.entitlement);
  };
  const signOut = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("pp_token");
    localStorage.removeItem("pp_ws");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, ent, refresh, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
